import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Flame } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { applySession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        applySession(data.access_token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}`);
        navigate("/portal", { replace: true });
      })
      .catch((e) => {
        toast.error(apiErr(e, "Google sign-in failed"));
        navigate("/login", { replace: true });
      });
  }, [applySession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-secondary text-white gap-4">
      <Flame className="text-primary animate-pulse" size={40} />
      <p className="text-slate-300">Signing you in…</p>
    </div>
  );
}
